import React from 'react'
import Navbar from './Navbar';
import Home from './home';

function combine() {
  return (
    <>
        <Navbar />
        <Home />
    </>
  )
}

export default combine;